import { Subscription } from 'rxjs';
import { UsersService } from '../users.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public errorMessage = '';
  private userID = '';
  public isLoading = false;
  public user: any;
  public roles: any;

  constructor(
    private route: ActivatedRoute,
    private usersService: UsersService,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    window.scroll(0, 0);
    this.isLoading = true;
    this.subscriptions.push(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        if (paramMap.has('id')) {
          this.userID = paramMap.get('id') || '';
          if (this.userID) {
            this.subscriptions.push(
              this.usersService.getUser(this.userID).subscribe(
                (result) => {
                  console.log('User desde DB: ', result);
                  if (result.length > 0) {
                    this.user = result[0];
                    this.subscriptions.push(
                      this.usersService.getUserRoles().subscribe(
                        (res) => {
                          console.log('Roles desde DB: ', res);
                          this.roles = res;
                          this.isLoading = false;
                        },
                        (err) => {
                          console.log('Error: ', err);
                          this.router.navigate(['/usuarios']);
                          this.isLoading = false;
                        }
                      )
                    );
                  }
                },
                (error) => {
                  console.log('Error: ', error);
                  this.router.navigate(['/usuarios']);
                  this.isLoading = false;
                }
              )
            );
          }
        }
      })
    );
  }

  /*onRoleChange(selected: any): void {
    console.log('Selected: ', selected);
    const selectElementValue = selected.target.value;
    console.log('Selected value: ', selected.target.value);
    const selectElementText =
      selected.target['options'][selected.target['options'].selectedIndex].text;
    console.log('Selected text: ', selectElementText);
    if (selectElementValue && selectElementText) {
      this.user.role_code = selectElementValue;
      this.user.role_description = selectElementText;
      console.log('User actualizado: ', this.user);
    }
  }*/

  onSubmit(form: NgForm): void {
    console.log(form);
    if (!form.invalid) {
      this.subscriptions.push(
        this.usersService
          .updateUser(
            form.value.firstname,
            form.value.surname,
            form.value.email,
            form.value.roleID,
            this.userID
          )
          .subscribe(
            (result) => {
              console.log(result);
              this.router.navigate(['/usuarios'], {
                state: { data: 'El usuario/a ha sido editado con éxito.' },
              });
            },
            (error) => {
              this.errorMessage = error.error.error.message || '';
              if (
                this.errorMessage &&
                this.errorMessage.includes('Duplicate entry') &&
                this.errorMessage.includes('email')
              ) {
                this.errorMessage =
                  'El e-mail ya existe. Por favor, especifique otro.';
              }
              window.scroll(0, 0);
            }
          )
      );
    }
  }
}
